import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { storeReturnedAccountId, linkCardStatusMsg } from '@kfc-global/react-shared/redux/Actions/LoyaltyMileageAction';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import ImageComponent from 'atoms/Image/Container/ImageComponent';
import { translateWithI18Next } from '@kfc-global/react-shared/i18n/i18N';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { ROUTE_URL } from 'common/constants/SharedConstants';

const LinkProcessing = props => {
  const dispatch = useDispatch();
  const linkingStatus = useSelector(data => data?.loyaltyMileageReducer?.linkingStatus);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const history = useHistory();

  const { LINK_PROCESSING, ERR_MSG } = TRANSLATE_MAPPING_KEY;

  // Check if the "W" parameter exists in the URL
  const hasWParam = searchParams.has('w');

  // If it exists, you can get its value using get method
  const wParamValue = searchParams.get('w');

  useEffect(() => {
    if (hasWParam && !linkingStatus?.message) {
      dispatch(storeReturnedAccountId(wParamValue));
    } else if (!hasWParam) {
      dispatch(linkCardStatusMsg({ success: false, message: translateWithI18Next(ERR_MSG) }));
    }

    if (linkingStatus?.message) {
      history.push(ROUTE_URL.MILEAGE_LOYALTY);
    }
  }, [wParamValue, hasWParam, dispatch, history, linkingStatus?.message, ERR_MSG]);

  return (
    <div className='link-processing'>
      <div className='kfc-loader' data-testid='kfc-loader-id'></div>
      <ImageComponent className='' srcFile={`${IMAGE_PATH.KFC_Loader_Gif}`} alt={'Loader'} />
      <div>{translateWithI18Next(LINK_PROCESSING)}</div>
    </div>
  );
};

export default LinkProcessing;
